/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import Skeleton from 'react-loading-skeleton'

interface UiOfferTimeslotSkeletonProps {
    index: number
}

const UiOfferTimeslotSkeleton: React.FC<UiOfferTimeslotSkeletonProps> = () => {
    return (
        <div className="UiOfferTimeslotSkeleton w-full min-w-[72px] h-[44px] sm:h-[56px] border border-solid border-gray-100 dark:border-gray-800/50 overflow-hidden rounded-lg flex leading-[1]">
            <Skeleton
                containerClassName={'flex-1'}
                height={'100%'}
                width={'100%'}
                baseColor={
                    document.documentElement.classList.contains('dark')
                        ? '#1f2937'
                        : '#f3f4f6'
                }
                highlightColor={
                    document.documentElement.classList.contains('dark')
                        ? '#374151'
                        : '#e5e7eb'
                }
            />
        </div>
    )
}

export default UiOfferTimeslotSkeleton
